export enum WeightUnit {
  Ton = 'TONNE',
  Kilo = 'KILOGRAM',
  Gram = 'GRAM'
}
